import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CmsService, TranslatePipe } from '@spartacus/core';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { Subscription } from 'rxjs';

import { KnBrCartQuoteSummaryService } from '../../../services/kn-br-cart-quote.service';
import { KnBrDraftOrdersService } from '../../../store/kn-br-draft-orders/kn-br-draft-orders.service';

@Component({
    selector: 'knbr-kn-br-draft-order-download-link',
    templateUrl: './kn-br-draft-order-download-link.component.html',
    styleUrls: ['./kn-br-draft-order-download-link.component.scss'],
    imports: [TranslatePipe]
})
export class KnBrDraftOrderDownloadLinkComponent implements OnInit {
  enableCheckboxFlag = false;
  subscription = new Subscription();
  selectedProductsCodes: string[] = [];
  productCodes: string[] = [];
  templateName: string;
  cart$ = this.activeCartService.getActive();
  cartStatus = '';
  constructor(
    protected activeCartService: ActiveCartService,
    protected knBrDraftOrderService: KnBrDraftOrdersService,
    protected knBrCartQuoteSummaryService: KnBrCartQuoteSummaryService,
    protected cdr: ChangeDetectorRef,
    protected cmsService: CmsService
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.knBrCartQuoteSummaryService.loadDownloadFlag$().subscribe((flag) => {
        this.enableCheckboxFlag = flag;
        this.cdr.markForCheck();
      })
    );
    this.subscription.add(
      this.knBrCartQuoteSummaryService.loadDraftOrderListSelectedProducts$().subscribe((codes) => {
        this.selectedProductsCodes = codes;
        this.cdr.markForCheck();
      })
    );
    this.subscription.add(
      this.knBrDraftOrderService.list$.subscribe((orders) => {
        if (orders) {
          this.productCodes = orders.map((order) => order.code);
        }
        this.cdr.markForCheck();
      })
    );

    this.subscription.add(
      this.cmsService.getCurrentPage().subscribe((page) => {
        if (page) {
          this.templateName = page.template;
        }
      })
    );
    this.cart$.subscribe((res: any) => {
      this.cartStatus = res.cartStatus;
    });
  }

  downloadPdf() {
    if (this.selectedProductsCodes) {
      this.knBrCartQuoteSummaryService.downloadDraftOrder(
        this.selectedProductsCodes.toString(),
        this.selectedProductsCodes.length > 1
      );
    }
    this.knBrCartQuoteSummaryService.setDownloadFlag(false);
  }
  downloadDraftOrderDetailPdf() {
    this.cart$
      .subscribe((response) => {
        if (response) {
          this.knBrCartQuoteSummaryService.downloadDraftOrder(response.code);
        }
      })
      .unsubscribe();
  }
  enableCheckbox() {
    this.knBrCartQuoteSummaryService.setDownloadFlag(true);
  }
  cancelDownload() {
    this.knBrCartQuoteSummaryService.setDownloadFlag(false);
  }

  downloadDraftOrderDetailImages() {
    this.cart$
      .subscribe((response) => {
        if (response) {
          this.knBrCartQuoteSummaryService.downloadDraftOrderImages(response.code);
        }
      })
      .unsubscribe();
  }

  downloadDraftOrderDetailCSV() {
    this.cart$
      .subscribe((response) => {
        if (response) {
          this.knBrCartQuoteSummaryService.downloadDraftOrderCSV(response.code);
        }
      })
      .unsubscribe();
  }

  deleteCart() {
    this.knBrDraftOrderService.delete(null);
  }
}
